module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#cancel",
      toString: function () {
        return this.url;
      }
    }